// Shows an error message from a js error

import PropTypes from 'prop-types'

function Error ({ error }) {
  return <div className='text-danger'>{error.message}</div>
}

Error.propTypes = {
  error: PropTypes.object.isRequired
}

export default Error
